import axios from "axios";

export const instance = axios.create({
  timeout: 10000
});

export const getExpertiseList = () => {
  const response = instance({
    method: "get",
    url: `/work/api/expertise`
  });
  return response;
}

export default {
  getExpertiseList
}
